module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.cue && _vm.cue.data) ? _c('md-toolbar', {
    ref: "ql-cue-header",
    staticClass: "md-dense ql-cue-header"
  }, [_c('div', {
    staticClass: "ql-cue-layer-func"
  }, [_c('div', {
    staticClass: "ql-cue-layer-func-back",
    style: ({
      backgroundColor: _vm.layer.color,
      height: (this.titleFontSize + 1) + 'px'
    }),
    on: {
      "click": _vm.toggle,
      "contextmenu": function($event) {
        return _vm.preventContextFunc($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cue-header-title",
    class: {
      'cue-header-both': [_vm.headerBox.title, _vm.headerBox.label, _vm.headerBox.time].filter(Boolean).length >= 2
    },
    style: (_vm.cueHeaderTitleStyles),
    attrs: {
      "id": 'cue-header-title-' + _vm.cue.id
    }
  }, [_c('layer-picker', {
    attrs: {
      "currentLayer": _vm.layer,
      "layers": _vm.layers,
      "editable": _vm.editable,
      "locked": _vm.locked,
      "totalPages": _vm.totalPages,
      "cue": _vm.cue,
      "titleFontSize": _vm.titleFontSize,
      "layerCueLineOpacity": _vm.cueLineOpacity,
      "layerCueBoxOpacity": _vm.cueBoxOpacity,
      "headerBox": _vm.headerBox,
      "selectedScale": _vm.selectedScale
    },
    on: {
      "selectLayer": _vm.selectLayer
    }
  }), _vm._v(" "), (_vm.showTitle || _vm.showLabel || _vm.showTime) ? _c('div', {
    staticClass: "cue-header-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.showTitle) ? _c('div', {
    staticClass: "cue-header-cue-title",
    class: {
      'placeholder': !_vm.cue.title,
      'short-box': (_vm.cue.title || '').length <= 12
    },
    style: (_vm.titleStyle),
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.cue.title || 'Cue Number') + "\n            "), (_vm.editable && !_vm.locked && !_vm.isEditing && !_vm.isEditingDescription) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showTitle && _vm.showLabel) ? _c('div', {
    staticClass: "cue-header-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.showLabel) ? _c('div', {
    staticClass: "cue-header-cue-description",
    class: {
      'placeholder': !_vm.cueLabel,
      'short-box': _vm.cueLabel.length <= 12
    },
    style: (_vm.titleStyle),
    on: {
      "click": _vm.editDescription
    }
  }, [_vm._v("\n            " + _vm._s(_vm.cueLabel || 'Cue Label') + "\n            "), (_vm.editable && !_vm.locked && !_vm.isEditing && !_vm.isEditingDescription) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.showTitle || _vm.showLabel) && _vm.showTime) ? _c('div', {
    staticClass: "cue-header-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.showTime) ? _c('div', {
    staticClass: "cue-header-cue-time",
    class: {
      'placeholder': !_vm.cue.data.time,
      'short-box': (_vm.cue.data.time || '').length <= 12
    },
    style: (_vm.titleStyle)
  }, [_vm._v("\n            " + _vm._s(_vm.cue.data.time || 'Cue Time') + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container",
    style: (_vm.tetherWrapperStyle)
  }, [_c('span', {
    staticClass: "move-button drag"
  }, [_c('div', {
    staticClass: "fill-button",
    style: (_vm.tetherStyle)
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d394072","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/cues/cue-header.vue
// module id = 1250
// module chunks = 21